<template>
    <div>
        <a-row :gutter="24" type="flex">
            <a-col :span="24" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
                    <template #title>
                        <a-row type="flex" align="middle">
                            <a-col :span="24" :md="12">
                                <h5 class="font-semibold m-0">جدول آگهی ها</h5>
                            </a-col>
                            <a-col :span="24" :md="12"
                                style="display: flex; align-items: center; justify-content: flex-end;">
                                <a-button class="btn-outline-purple" icon="search" @click="isHidden = !isHidden">
                                    جستجو
                                </a-button>
                                &nbsp;
                                <a-button href="/products/add" class="btn-outline-blue" icon="plus" v-show="$root.hasPermission('/products/add/')">
                                    افزودن محصول
                                </a-button>
                                &nbsp;
                            </a-col>
                        </a-row>
                    </template>
                    <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
                            <a-row>
                                <a-col :md="5" style="margin:2% !important;">
                                <UserSearch @ids="getIds" />

                                </a-col>
                               
                                <a-col :md="5" style="margin:2% !important;">
                                    <label class="sr-only" for="inline-form-input-name">
                                        دسته بندی</label>
                                        <a-select mode="multiple" style="width:100%" placeholder="انتخاب دسته بندی "
                                    v-model="search.category_id">
                                    <a-select-option v-for="cat in cats" :key="cat.id" :value="cat.id">
                                        {{ cat . title }}
                                    </a-select-option>
                                </a-select>
                                </a-col>
                                <a-col :md="5" style="margin:2% !important;">
                                    <label class="sr-only" for="inline-form-input-name">
                                        بر اساس وضعیت</label>
                                    <a-select style="width: 100%" placeholder=" وضعیت" v-model="search.status">
                                        <a-select-option value="">
                                            انتخاب
                                        </a-select-option>
                                        <a-select-option value="0">
                                            غیرفعال
                                        </a-select-option>
                                        <a-select-option value="1">
                                            فعال
                                        </a-select-option>
                                    </a-select>
                                </a-col>
                                <a-col :md="5" style="margin:2% !important;">
                                    <label class="sr-only" for="inline-form-input-name">
                                        عنوان</label>
                                    <b-form-input v-model="search.title" id="inline-form-input-name"
                                        class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                                </a-col>
                                 <a-col :md="5" style="margin:2% !important;">
                                    <label class="sr-only" for="inline-form-input-name">
                                        نام کمپانی</label>
                                    <b-form-input v-model="search.company_name" id="inline-form-input-name"
                                        class="mb-2 mr-sm-2 mb-sm-0"></b-form-input>
                                </a-col>
                            </a-row>
                            <a-col :md="4" style="margin:2% !important;">
                                <a-button class="btn-outline-green w-100" icon="search" @click="getData">
                                    جستجو
                                </a-button>
                            </a-col>
                    </b-card>
                    <a-row style="justify-content: center; display: flex" v-if="$store.state.loading">
                        <template>
                            <div>
                                <a-spin />
                            </div>
                        </template>
                    </a-row>
                    <div v-else>
                        <section class="w-100 p-4 text-center">
                            <div class="table-responsive">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">شناسه</th>
                                        <th scope="col">عنوان</th>
                                        <th scope="col">فروشنده</th>
                                        <th scope="col"> قیمت اصلی</th>
                                        <th scope="col"> قیمت با تخفیف</th>
                                        <th scope="col"> تهاتر</th>
                                        <th scope="col"> مبلغ نقدی</th>
                                        <th scope="col"> استان و شهر</th>
                                        <th scope="col">فعال کردن آگهی</th>
                                        <th scope="col">  پیشنهاد ویژه</th>
                                        <th scope="col"> لغو از طرف مشتری</th>
                                        <th scope="col"> مشاهده</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="row in data">
                                        <th scope="row">#{{ row . id }}</th>
                                        <td>
                                            <b-avatar size="1.5rem"
                                                :src="row.images[0] ? $root.image_concat(row.images[0].path) : ''">
                                            </b-avatar>

                                            <b-badge variant="light" class="text-dark">{{ row . title }}</b-badge>
                                        </td>
                                         <td>
                                            <b-badge  class="text-light bg-success">{{ row . presenter . information ? row.presenter.information.company_name : '' }}</b-badge>
                                            <br>
                                            <b-badge variant="light" class="text-dark">{{ row . presenter ? $root.full_name(row.presenter.firstname,row.presenter.lastname) : '' }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="bg-secondary">
                                                {{ $root . number_format(row . cost) }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="bg-secondary">
                                                {{ $root . number_format(row . discounted_cost) }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge pill variant="info" class="bg-info">
                                                {{ $root . number_format(row . barter) }}</b-badge>
                                        </td>
                                        <td>
                                            <b-badge variant="light" class="bg-secondary">
                                                {{ $root . number_format(row . cash) }}</b-badge>
                                        </td>
                                      
                                        <td>
                                            <b-badge variant="light" class="text-dark">
                                                {{ (row && row.state && row.state.name ? row.state.name : '') + (row && row.city && row.city.name ? ', ' + row.city.name : '') }}
                                            </b-badge>
                                        </td>
                                        <td>
                                            <a-switch v-model="row.status" @change="changeStatus(row.id)" :disabled="!$root.hasPermission('/products/status/')" />
                                        </td>
                                        <td>
                                            <a-switch v-model="row.offer" @change="changeOffer(row.id)" :disabled="!$root.hasPermission('/products/offer/')" />
                                        </td>
                                        <td>
                                            <span v-if="row.disabled">لغو شده</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td>
                                            <a-button class="btn-outline-info" shape="square" icon="eye" :href="'/products/edit/'+row.id" v-show="$root.hasPermission('/products/edit/')" />
                                            &nbsp;
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                        </section>
                        <a-row class="pagination">
                            <a-pagination :total="total" :item-render="$root.itemRender"
                                @change="getData(currentPage)" v-model="currentPage" />
                        </a-row>
                    </div>
                </a-card>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"

    export default {
        components: {
            UserSearch
        },
        data() {
            return {
                data: [],
                users:[],
                cats: [],
                currentPage: 1,
                total: 0,
                isHidden: false,
                search: {
                    title: "",
                    status:[],
                    category_id:[],
                    seller_id:[],
                    company_name:""
                },
            };
        },
        methods: {
            getIds(value) {
                this.search.seller_id=value
            },
            async getData() {
                let _this = this;
                this.$store.state.loading = true;
                let url = `/products?page=${this.currentPage}&&title=${this.search.title}&&status=${this.search.status}&&category_id=${this.search.category_id}&&seller_id=${this.search.seller_id}&&company_name=${this.search.company_name}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.data = response.data.data;
                        _this.$store.state.loading = false;
                        _this.total = response.data.total;
                        _this.currentPage = response.data.current_page;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async changeStatus(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/products/status/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.getData();
                        _this.$toast.success("محصول مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
            async changeOffer(id){
              let _this = this;
                this.$store.state.loading = true;
                let url =
                    `/products/offer/${id}`;
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.$toast.success("محصول مورد نظر با موفقیت ویرایش شد.");

                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
                                            this.getData();

            },
            async getCats() {
                let _this = this;
                let url = '/categories/all';
                await axios
                    .get(url)
                    .then(function(response) {
                        _this.cats = response.data.data;
                    })
                    .catch(function(err) {
                        _this.$root.handleAxiosError(err);
                    });
            },
        },
        mounted() {
            this.getData();
            this.getCats();
        },
    };
</script>

<style scope>
    .pagination {
        display: flex;
        justify-content: center;
        margin: 15px;
    }
</style>
